import React from 'react'
import history from '../../../lib/history'
import routes from '../../../config/routes'
import ExternalLayout from '../../commons/Layouts/ExternalLayout'
import FeedbackLayout from '../../commons/Layouts/FeedbackLayout'
import blockedImg from './blockedImg.svg'

export const TITLE = 'A sua conta está bloqueada'

export const SUBTITLE = `Por motivos de segunça, a sua conta está bloqueada por tentativas de login com o endereço de e-mail ou senha inválida.

Para voltar a ter acesso, faça a redefinição da sua senha.`

export const PRIMARY_LABEL = 'Redefinir a senha'

export const SECONDARY_LABEL = 'Voltar para login'

const LoginBlockedFeedbackContainer = () => {
  return (
    <ExternalLayout>
      <FeedbackLayout
        title={TITLE}
        subTitle={SUBTITLE}
        primaryAction={() => history.push(routes.resetPasswordSentEmail.path)}
        primaryLabelAction={PRIMARY_LABEL}
        secondaryAction={() => history.push(routes.login.path)}
        secondaryLabelAction={SECONDARY_LABEL}
        image={blockedImg}
      />
    </ExternalLayout>
  )
}

export default LoginBlockedFeedbackContainer
